import { Typography } from '@speeki/global-ui-components';

import { CardBadgeWrapper } from './CardBadge.styled';

interface CardBadgeProps {
    children: React.ReactNode;
}

export const CardBadge = ({ children }: CardBadgeProps) => {
    return (
        <CardBadgeWrapper>
            <Typography.TextBody_10_16 fontWeight="bold">
                {children}
            </Typography.TextBody_10_16>
        </CardBadgeWrapper>
    );
};
